module.exports = __webpack_public_path__ + "img/project-overview-billing-beforEnd.999ef3be.svg";